const CLASS_UNLABELLED_COLOR = "#B3B3AE";

const CLASS_COLORS: Readonly<Record<string, string>> = {
  "globala aktier": "#5F54EB",
  "svenska aktier": "#7766ED",
  värdeaktier: "#9F89F0",
  småbolagsaktier: "#C4B5FD",
  momentumaktier: "#4C3FD0",
  lågriskaktier: "#6E7BF2",
  tillväxtmarknadsaktier: "#3B2FA8",

  "private equity": "#C2185B",
  "privata bolag": "#E91E8C",
  hedgefonder: "#F06292",

  "företagsobl. (hdg)": "#E65100",
  företagsobligationer: "#FB8C00",
  highyieldobligationer: "#FFB300",
  "highyieldobl. (hdg)": "#FFDB4A",
  "tillväxtmarknadsobl.": "#C77800",

  fastigheter: "#05D48F",
  skog: "#2E7D32",
  guld: "#D4AF37",

  "svenska statsobligationer": "#1565C0",
  "amerikanska statsobl.": "#0288D1",
  "japanska statsobl.": "#4DD0E1",

  penningmarknad: "#78909C",
  likviditet: "#B0BEC5",
  "belåning (ltv)": "#546E7A",
  unmapped: "#9E9E99",
  "custom class": "#8D8D87",
};

function classPaletteKey(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, " ");
}

const CLASS_COLOR_RAMP: readonly string[] = Object.values(CLASS_COLORS);

function fnv1a(input: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

export function classColor(name: string | null): string {
  if (!name) return CLASS_UNLABELLED_COLOR;
  const key = classPaletteKey(name);
  if (!key) return CLASS_UNLABELLED_COLOR;
  const known = CLASS_COLORS[key];
  if (known) return known;
  return CLASS_COLOR_RAMP[fnv1a(key) % CLASS_COLOR_RAMP.length];
}
